import { useTransferInstructions } from '@hooks/queries/registry/transferInstruction/useTransferInstructions';
import { TransferInstruction } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundTransferInstructions = () => {
  const { party } = useParties();

  const transferInstructions = useTransferInstructions();
  const data = transferInstructions.data?.map((r) => {
    const { transfer } = r.view(TransferInstruction);
    const payload = {
      sender: transfer.sender,
      receiver: transfer.receiver,
    };
    return {
      payload,
    };
  });
  const transfers2Step = (data || []).filter((t) => t.payload?.receiver === party);
  return transfers2Step;
};
